export const getDocumentTypeFromNotification = (notification = {}) => {
  if (notification.agreement) {
    return 'agreement';
  }

  if (notification.judgment) {
    return 'judgment';
  }
};
